// 9fbef606107a605d69c0edbcd8029e5d
import { getCardTypeViaNumber } from '../../../../features/CnC/Checkout/util/utility';

export const clearNumber = (value = '') => {
  return value.replace(/[^0-9*]+/g, '');
};

export const formatCreditCardNumber = (value) => {
  if (!value) {
    return value;
  }

  const clearValue = clearNumber(value);
  const issuer = getCardTypeViaNumber(clearValue);
  const cardType = issuer?.toLowerCase();

  let nextValue;

  switch (cardType) {
    case 'amex':
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 10)} ${clearValue.slice(
        10,
        15
      )}`;
      break;
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 8)} ${clearValue.slice(
        8,
        12
      )} ${clearValue.slice(12, 19)}`;
      break;
  }
  return nextValue.trim();
};

export const removeSpaces = (value = '') => {
  return value?.replace(/ /g, '');
};
